<div class='remove-container p-2 mb-2'>
  <h4>{{ title }}</h4>
  <p>{{ description }}</p>
  <button (click)='confirmedDelete.emit()' class='btn btn-danger btn-sm'>{{ 'BUTTON.DELETE' | translate }}</button>
</div>
